import { ContactsConfigOptions } from 'common/models/Configuration/Contacts';
import { ChangeTracker } from 'common/models/hooks/ChangeTracker';

export const DefaultOptions: ContactsConfigOptions = {
  ContactDefaultSummary: '',
  AutoAddRefereesAsContacts: 'true',
};

export const NoChangesTracker: ChangeTracker<ContactsConfigOptions> = {
  ContactDefaultSummary: false,
  AutoAddRefereesAsContacts: false,
};
